const getDaysInMonth = (date: Date): number[] => {
  const daysCount = new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate()
  return Array.from({ length: daysCount }, (_, index) => index + 1)
}

export default getDaysInMonth
